module.exports = __webpack_public_path__ + "static/img/404.5ced8f1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/404.gif
// module id = +2J0
// module chunks = 26